import React from 'react';
import { HiOutlineChevronDown } from 'react-icons/hi2';

const FAQ_ITEMS = [
  {
    question: 'What does the Light Plan unlock?',
    answer: 'The Light plan is our most affordable entry to the Cloud Platform. It unlocks the full PRO Browser Extension (unlimited local extractions, all exports, multi-tab) and includes 3,000 monthly cloud credits to run scheduled extractions, cloud browsers, and AI features like Page Unblocker and Data Labeling. Ideal for individuals who want both PRO locally and a small cloud allowance.',
  },
  {
    question: 'What are credits and how do they work?',
    answer: 'Each page collected costs 1 credit. Some features consume additional credits when used: Page Unblocker (solving captchas, dismissing popups), Proxies, and Data Labeling (AI-powered column naming). Your monthly credits reset at the start of each billing cycle, and any purchased top-up credits remain valid for 12 months.',
  },
  {
    question: 'Can I change my plan at any time?',
    answer: 'Yes. You can upgrade or downgrade your plan at any time. When upgrading, you get immediate access to your new plan features and credits. When downgrading, the change takes effect at the end of your current billing cycle.',
  },
  {
    question: 'Can I invite my team?',
    answer: 'Yes — Pro includes 3 seats and Max includes 10 seats in a shared workspace. Every teammate gets full PRO Browser Extension access and shares the same dashboard, automations, and credit pool. Invite or remove members anytime from the Account page. Light and Starter are single-seat plans.',
  },
  {
    question: 'What happens when my credits run out?',
    answer: 'Your scraping tasks will pause when credits reach zero. You can purchase a credit top-up pack at any time to resume immediately, or wait for your next monthly renewal.',
  },
  {
    question: 'What is a cloud browser?',
    answer: 'A cloud browser is a browser running in the cloud that executes your data collection tasks. For example, with 3 parallel cloud browsers on the Pro plan, you can collect data from three different sources simultaneously, significantly speeding up your workflow.',
  },
  {
    question: 'What kind of data can I collect?',
    answer: 'You can collect virtually any publicly available data from the web — product prices, real estate listings, business directories, job postings, reviews, search results, lead lists, social media profiles, and more. If you can see it in a browser, you can collect it.',
  },
  {
    question: 'Do unused credits roll over?',
    answer: 'Monthly subscription credits reset at the end of each billing cycle and do not roll over. However, credits purchased via top-up packs have a 12-month expiration window, giving you flexibility.',
  },
  {
    question: 'How long can I run automations for?',
    answer: 'You are charged per page, not by time. With that said, there is a 24-hour limit per automation on paid plans and a 1-hour limit on the free plan.',
  },
  {
    question: 'Do I unlock the PRO version of the Browser Extension?',
    answer: 'Yes! Every paid plan includes the full PRO Browser Extension with all features unlocked. On Pro and Max plans you can also invite teammates to a shared workspace — every member gets the full PRO extension at no extra cost.',
  },
  {
    question: 'What is the refund policy?',
    answer: 'We offer a 7-day refund window. If you haven\'t used any credits or cloud resources, you\'re eligible for a full refund. Partial refunds may be considered depending on usage. You can cancel your subscription anytime from your dashboard — your plan stays active until the end of your billing period. Full policy at ultimatewebscraper.com/refund-policy.',
  },
  {
    question: 'I already bought a lifetime license — does it still work?',
    answer: 'Yes — your lifetime license still works exactly as before. Just use your license key to register the extension and unlock PRO from Settings. No subscription required.',
  },
];

const FAQSection = ({ openIndex, setOpenIndex }) => (
  <div className="rounded-xl border border-gray-200 dark:border-gray-700/30 bg-gradient-to-br from-gray-50 dark:from-gray-900/60 to-gray-100 dark:to-gray-800/40 px-8 py-8">
    <div className="text-center mb-8">
      <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        Questions? We've Got Answers.
      </h3>
      <p className="text-sm text-gray-500 dark:text-gray-400">
        Everything you need to know about our plans and billing
      </p>
    </div>

    <div className="space-y-0">
      {FAQ_ITEMS.map((item, index) => (
        <div key={index} className={`border-b border-gray-200 dark:border-gray-800/50 transition-all duration-300 pl-4 -ml-4 ${
              openIndex === index
                ? 'border-l-2 border-l-cyan-500 dark:border-l-cyan-400'
                : 'border-l-2 border-l-transparent'
            }`}>
          <button
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
            className="w-full flex items-center justify-between py-5 text-left group"
          >
            <span className={`text-base font-semibold transition-colors ${
              openIndex === index
                ? 'text-cyan-500 dark:text-cyan-400'
                : 'text-gray-700 dark:text-gray-300 group-hover:text-cyan-500 dark:group-hover:text-cyan-400'
            }`}>
              {item.question}
            </span>
            <HiOutlineChevronDown className={`w-5 h-5 flex-shrink-0 ml-4 text-gray-400 dark:text-gray-500 group-hover:text-cyan-500 dark:group-hover:text-cyan-400 transition-all duration-300 ${
              openIndex === index ? 'rotate-180 !text-cyan-500 dark:!text-cyan-400' : ''
            }`} />
          </button>

          <div className={`overflow-hidden transition-all duration-300 ${
            openIndex === index ? 'max-h-56 opacity-100 pb-7' : 'max-h-0 opacity-0'
          }`}>
            <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed pr-8">
              {item.answer}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default FAQSection;
